import { render, staticRenderFns } from "./EmployeePage.vue?vue&type=template&id=352afc03&"
import script from "./EmployeePage.vue?vue&type=script&lang=js&"
export * from "./EmployeePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports